import { combineReducers } from 'redux';
import InventoryAdjustmentReducer from './inventory/reducer_inventory_adjustment';
import InventoryStocktakeReducer from './inventory/reducer_inventory_stocktake';
import InventoryTransferReducer from './inventory/reducer_inventory_transfer';

export const inventoryReducer = combineReducers({
  'adjustment': InventoryAdjustmentReducer,
  'stocktake': InventoryStocktakeReducer,
  'transfer' : InventoryTransferReducer,
});